import { makeStyles } from '@material-ui/core'

/**
 * Shared styles for the group-by multi-select in hierarchy level editors.
 * Used by HierarchicalTableConfigEditor and HierarchicalPivotTableConfigEditor.
 */
const useGroupBySelectStyles = makeStyles(() => ({
  inputRoot: {
    width: '100%',
    border: 'var(--border-neutral-thin)',
    borderRadius: 'var(--border-radius-sm)',
    backgroundColor: 'var(--color-surface-050)',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    transition: 'outline 200ms ease-in-out',
    outline: '1px solid transparent',
    '&:focus-within': {
      outline: '1px solid var(--color-primary-500)'
    }
  },
  input: {
    fontFamily: 'var(--root-font) !important',
    fontSize: 'var(--font-size-sm)',
    padding: '2px 10px',
    minHeight: '32px',
    lineHeight: '32px',
    border: 'none',
    backgroundColor: 'transparent',
    '&:focus': {
      outline: 'none',
      backgroundColor: 'transparent'
    }
  },
  select: {
    borderRadius: 'var(--border-radius-sm)'
  },
  menuPaper: {
    boxShadow: '0px 4px 12px 0px rgba(24, 27, 53, 0.2)'
  },
  menuList: {
    borderRadius: 'var(--border-radius-md)',
    padding: 0,
    minWidth: '300px'
  },
  menuItem: {
    background: 'var(--theme-color-surface-d0)',
    padding: '4px 8px',
    fontSize: '14px',
    '&.Mui-selected': {
      background: 'var(--color-surface-050)'
    }
  }
}))

export { useGroupBySelectStyles }
export default useGroupBySelectStyles
